import * as Yup from "yup";

export const CrossCountry = Yup.object().shape({
    eventClassId: Yup.string().required("Class required"),
    optimumTime:Yup.string().required("Optimum Time Required"),
    courseLength:Yup.string().required("Course Lenght Required"),
    image:Yup.string().required('Image is Required'),
    nofences: Yup.string().required("No. of Fence Required"),
});